import React from "react";
import { AlertTriangle } from "lucide-react";

// Warning banner shown at the top of PropertyListingDetail /
// OfficeBuildingDetail when a doc is missing fields the public site
// needs to render a usable card / detail page.
//
// Renders nothing when `missing` is empty — the caller doesn't have
// to guard against clean docs.
//
// `missing` shape: [{ key, label, where }] from
// getListingMissingFields() or getBuildingMissingFields() in
// utils/incompleteChecks.js. `where` is a short human hint about
// which surface to edit each field on.
export default function IncompleteWarning({ missing }) {
  if (!Array.isArray(missing) || missing.length === 0) return null;
  const count = missing.length;

  return (
    <section
      role="alert"
      className="mb-6 rounded-2xl border border-amber-300 bg-amber-50 shadow-sm overflow-hidden"
    >
      <div className="flex items-start gap-3 px-5 py-4">
        <div className="shrink-0 mt-0.5 w-9 h-9 rounded-full bg-amber-100 text-amber-700 flex items-center justify-center">
          <AlertTriangle className="w-5 h-5" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-sm font-semibold text-amber-900 m-0">
            {count === 1
              ? "Missing 1 requirement for the public website"
              : `Missing ${count} requirements for the public website`}
          </h3>
          <p className="text-xs text-amber-800 mt-1">
            This entry will soon be hidden automatically until every
            required field is filled in. Review the list below and
            complete each item.
          </p>
          <ul className="mt-3 space-y-1.5 text-sm text-amber-950">
            {missing.map((item) => (
              <li key={item.key} className="flex items-baseline gap-2">
                <span
                  aria-hidden="true"
                  className="shrink-0 w-1.5 h-1.5 rounded-full bg-amber-500 translate-y-1"
                />
                <span className="flex-1">
                  <span className="font-medium">{item.label}</span>
                  {item.where ? (
                    <span className="text-amber-700"> · {item.where}</span>
                  ) : null}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
